
  <aio-nav-item *ngFor="let node of filteredNodes" [node]="node" [selectedNodes]="currentNode?.nodes" [isWide]="isWide">
  </aio-nav-item>


// WEBPACK FOOTER //
// /home/wzc/dev/angular/angular/aio/src/app/layout/nav-menu/nav-menu.component.ts.NavMenuComponent.html